export default class ErpProductSupplierEntity {
    static getEntityData(elem: any) {
        return {
            id: elem.querySelector("#erp_product_supplier_id") ? (elem.querySelector("#erp_product_supplier_id") as HTMLInputElement).value : null,
            supplierId: elem.querySelector("#erp_product_supplier_supplier_id") ? (elem.querySelector("#erp_product_supplier_supplier_id option:checked") as HTMLInputElement).value : (elem.querySelector("#new_erp_product_supplier_supplier_id option:checked") as HTMLInputElement).value,
            stockNotify: parseInt((elem.querySelector("#erp_product_supplier_stockNotify") as HTMLInputElement).value),
        }
    }
}